export const whyUsText = {
  en: {
    heading: "Why Hire Our Team?",
    quote: "A Complete Team Ready to Work. No Need to Search Separately",
    ctaTitle: "Hire Our Team Right Now!!!",
    ctaButton: "Get Started",
    reasons: [
      {
        number: "1",
        title: "Complete Team in One Package",
        description:
          "Developers, designers, security experts and cloud specialists in one team. No separate hires needed.",
      },
      {
        number: "2",
        title: "Trained and Ready to Work",
        description:
          "Trained, prepared and productive from day one, with no ramp-up before your project moves.",
      },
      {
        number: "3",
        title: "Versatile Expertise",
        description:
          "Frontend to backend, design to deployment, security to cloud. We adapt to any requirement.",
      },
      {
        number: "4",
        title: "Expert in Modern Technologies",
        description:
          "AI, cloud platforms, DevOps and modern frameworks for scalable, future-ready solutions.",
      },
      {
        number: "5",
        title: "Dedicated Partnership",
        description:
          "We integrate with your team and stay past delivery, optimizing and supporting as you grow.",
      },
      {
        number: "6",
        title: "Transparent Communication & Reliable Support",
        description:
          "Regular updates, open channels and dedicated support keep the project running smoothly.",
      },
    ],
  },
  es: {
    heading: "¿Por qué contratar nuestro equipo?",
    quote:
      "Un Equipo Completo Listo para Trabajar. No Necesitas Buscar por Separado",
    ctaTitle: "¡Contrata Nuestro Equipo Ahora Mismo!",
    ctaButton: "Empezar",
    reasons: [
      {
        number: "1",
        title: "Equipo Completo en un Solo Paquete",
        description:
          "Desarrolladores, diseñadores y especialistas en seguridad y nube en un solo equipo.",
      },
      {
        number: "2",
        title: "Entrenados y Listos para Trabajar",
        description:
          "Entrenados, preparados y productivos desde el primer día, sin tiempo de arranque.",
      },
      {
        number: "3",
        title: "Expertise Versátil",
        description:
          "Del frontend al backend, del diseño al despliegue y la nube. Nos adaptamos a todo.",
      },
      {
        number: "4",
        title: "Expertos en Tecnologías Modernas",
        description:
          "IA, plataformas cloud, DevOps y frameworks modernos para soluciones escalables.",
      },
      {
        number: "5",
        title: "Socio Dedicado",
        description:
          "Nos integramos con tu equipo y seguimos tras la entrega, optimizando y dando soporte.",
      },
      {
        number: "6",
        title: "Comunicación Transparente y Soporte Confiable",
        description:
          "Actualizaciones regulares, canales abiertos y soporte dedicado durante el proyecto.",
      },
    ],
  },
  ja: {
    heading: "なぜ私たちのチームを雇うのか？",
    quote: "完全なチームが働く準備ができている。別々に探す必要はない",
    ctaTitle: "今すぐ私たちのチームを雇おう！",
    ctaButton: "始める",
    reasons: [
      {
        number: "1",
        title: "1つのパッケージで完全なチーム",
        description:
          "開発者、デザイナー、セキュリティとクラウドの専門家を1つのチームで。個別に探す必要はありません。",
      },
      {
        number: "2",
        title: "訓練され、働く準備ができている",
        description:
          "訓練され準備が整ったチーム。初日からプロジェクトを前に進めます。",
      },
      {
        number: "3",
        title: "多様な専門知識",
        description:
          "フロントエンドからバックエンド、デザインからデプロイ、クラウドまで柔軟に対応します。",
      },
      {
        number: "4",
        title: "最新技術の専門家",
        description:
          "AI、クラウド、DevOps、最新フレームワークでスケーラブルな基盤を構築します。",
      },
      {
        number: "5",
        title: "専任のパートナーシップ",
        description:
          "チームに溶け込み、納品後も最適化とサポートを継続します。",
      },
      {
        number: "6",
        title: "透明なコミュニケーションと信頼できるサポート",
        description:
          "定期的な更新とオープンな連絡体制、専任サポートで円滑に進行します。",
      },
    ],
  },
};
